import React, { useEffect, useRef } from "react";
import { ArrowRight, ChevronDown, ChartBar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EmpoweringColoradosFuture() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.log("Video autoplay failed:", error);
      });
    }
  }, []);
  return <section id="empowering-colorados-future" className="dark bg-background text-foreground relative h-screen min-h-[600px] w-full overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <video ref={videoRef} className="h-full w-full object-cover" autoPlay loop muted playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1208726/img/denver_skyline_sunset.png">
          <source src="/video/denver_skyline_sunset.mp4" type="video/mp4" />
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1208726/img/denver_skyline_sunset.png" alt="Denver skyline at sunset" className="h-full w-full object-cover" />
        </video>
        {}
        <div className="absolute inset-0 bg-black/40" />
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
      </div>

      {}
      <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        <div ref={textRef} className={`max-w-5xl transition-all duration-1000 ease-out ${textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          {}
          <h1 className="font-serif text-5xl font-extrabold leading-tight tracking-tight text-white sm:text-6xl md:text-7xl lg:text-8xl">
            Empowering Colorado&apos;s{" "}
            <span className="bg-gradient-to-r from-[hsl(38,92%,55%)] to-[hsl(38,85%,60%)] bg-clip-text text-transparent">
              Future
            </span>
          </h1>

          {}
          <p className="mx-auto mt-6 max-w-2xl text-lg font-medium text-white/90 sm:text-xl md:mt-8 md:text-2xl">
            Driving economic growth, leadership, and policy for the Hispanic
            business community since 1978.
          </p>

          {}
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
            <Button asChild size="lg" className="h-14 bg-[hsl(38,92%,55%)] px-8 text-lg font-bold text-[hsl(217,64%,11%)] hover:bg-[hsl(38,92%,55%)]/90 sm:w-auto">
              <Link to="/JoinUsPage">
                Join the Movement
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="h-14 border-white/30 bg-white/10 px-8 text-lg font-semibold text-white backdrop-blur-sm hover:bg-white/20 hover:text-white sm:w-auto">
              <Link to="/IntelligencePage">
                <ChartBar className="mr-2 h-5 w-5" />
                View Economic Data
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 z-20 -translate-x-1/2 animate-bounce">
        <div className="flex flex-col items-center gap-2 text-white/80">
          <span className="text-xs font-medium uppercase tracking-widest">
            Explore
          </span>
          <ChevronDown className="h-6 w-6" />
        </div>
      </div>
    </section>;
}